import {
  CompetenciesEmployeesRootPageAssessmentGroupFragment,
  CompetenciesProfileRootPageAssessmentGroupFragment,
} from 'generated/resources/graphql'

import BlankSlate from './BlankSlate'
import Competencies from './Competencies/Content'

interface AssessmentsProps {
  isEmpty: boolean
  assessmentGroup?:
    | CompetenciesProfileRootPageAssessmentGroupFragment
    | CompetenciesEmployeesRootPageAssessmentGroupFragment
  hasNextPage: boolean
  hasPreviousPage: boolean
  onNextPage: () => void
  onPreviousPage: () => void
}

const Assessments = ({
  isEmpty,
  assessmentGroup,
  hasNextPage,
  hasPreviousPage,
  onNextPage,
  onPreviousPage,
}: AssessmentsProps) => {
  if (!assessmentGroup || isEmpty) return <BlankSlate />

  return (
    <Competencies
      assessmentGroup={assessmentGroup}
      hasNextPage={hasNextPage}
      hasPreviousPage={hasPreviousPage}
      onNextPage={onNextPage}
      onPreviousPage={onPreviousPage}
    />
  )
}

export default Assessments
